import React, { useState } from 'react';
import { Button, Modal, Timeline, Typography } from 'antd';
import { InfoCircleOutlined } from '@ant-design/icons';
import Container from '@app/components/General/Container'
import {getAll} from '../../apis/BitacoraApi';
import moment from 'moment';
const { Text, Link } = Typography;
const InfoTracking = ({entity, entityId}) => {
    const [_open, setOpen] = useState(false);
    const [data, setData] = useState([]);

    const showModal = async () => {
      await getData();
      setOpen(true);
    };
    const handleCancel = () => {
      setOpen(false);
    }

    const getData = async () => {
      const response =  await getAll(entity, entityId);
      if(response.ok){
        let history = response.payload;
        let listEvents = [];
        for (let index = 0; index < history.length; index++) {
          const item = history[index];
          let date = moment(item.date).format('DD/MM/YYYY hh:mm')
          if(item.action == 'after_insert')
            listEvents.push({
              color: 'green',
              children: <>
                <Text>Se creo el registró</Text><br/>
                <Text type="secondary">{date}</Text><br/>
                <Text italic>{item.user_name}</Text>
              </>
            });
          if(item.action == 'after_update')
              listEvents.push({
                color: 'blue',
                children: <>
                  <Text>Se modificó el registró</Text><br/>
                  {item.descripcion && <Text type="secondary">({item.descripcion})</Text>}<br/>
                  <Text type="secondary">{date}</Text><br/>
                  <Text italic>{item.user_name}</Text>
                </>
              });
        }
        setData(listEvents);
      }
    }
  
    return <>
        <span><InfoCircleOutlined style={{marginRight: 5, color: '#2E2D75'}} onClick={showModal}/></span>
        {
            (_open) && 
            <Modal title={'Historial de cambios'} open={_open} onCancel={handleCancel} footer={[]}>
                <Container>
                <Timeline
                    mode="alternate"
                    items={data}
                  />
                </Container>
            </Modal>
        }
    </>
};
  
export default InfoTracking;